import { render, staticRenderFns } from "./UploadFactoryPackingList.vue?vue&type=template&id=6b2f37e6"
import script from "./UploadFactoryPackingList.vue?vue&type=script&lang=ts"
export * from "./UploadFactoryPackingList.vue?vue&type=script&lang=ts"
import style0 from "./UploadFactoryPackingList.vue?vue&type=style&index=0&id=6b2f37e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports